<template>
  <div class="quiz_no_list"><p>{{text}}</p></div>
</template>

<script>
export default {
  name: 'QuizNoList',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .quiz_no_list {
    background: #fff;
    border-radius: 48px 0 48px 0;
    margin: 0 45px 50px;
    min-width: 840px;
    height: 100px;
    padding: 30px;
    text-align: center;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_no_list {
      margin: 0 3% 50px;
      min-width: auto;
    }
  }
</style>
